const APP_LANGUAGE_NAME = "com.walmart.phronesis.lang"

export const getStoredLanguage = (): string | null => {
	return localStorage.getItem(APP_LANGUAGE_NAME)
}

export const removeStoredLanguage = (): void => {
	localStorage.removeItem(APP_LANGUAGE_NAME)
}

export const setStoredLanguage = (lang: string): void => {
	localStorage.setItem(APP_LANGUAGE_NAME, lang)
}
